import {Page} from './Page.js';

class Form
{
	constructor ( _$form, _bHandleSubmit = true, _closureSubmit = null )
	{
		
		if ( !_$form.is('form') )
		{
			return false;
		}
		this.$form = _$form;

		this.$header = (Page.getBody()).find('> header');


		this.bindEvents(_bHandleSubmit, _closureSubmit);
	}

	bindEvents (_bHandleSubmit, _closureSubmit)
	{
		this.$form.on('focus', 'fieldset input[type="text"], fieldset input[type="password"], fieldset select, fieldset textarea', Form.setFocus);
		this.$form.on('blur', 'fieldset input[type="text"], fieldset input[type="password"], fieldset textarea', Form.removeFocus);
		this.$form.on('change blur', 'fieldset select', Form.changeSelect);
		
		if (_bHandleSubmit)
        {
            this.$form.submit(this.submit.bind(this));
       
        }
        else if (_closureSubmit != null) //Submit is handle by another class, probably PageReservation
		{
            this.$form.submit(_closureSubmit);
            
		}
        
		this.$form.find("[data-type='uploader']").each(this.bindUploader.bind(this));
		
		this.bindDatePicker();
		console.log(this.$form);
	}
	
	bindUploader ($_index, _el)
	{
		console.log("bindUploader to fomr");
		let $btn = $(_el);
		
		let $progress = $btn.siblings(".progress_container");
		
		$progress.find(".progress").css("width", "0%");
        
        let strLang = this.$form.find("#lang").val();
        
        let strMode = "as-is";
        
        let objParams = {chunksFolder: "chunks", tempFolder: "temp", saveFolder : "files", "mode": strMode };
        
        let arrValidations = ['jpeg', 'jpg', 'gif', 'png', 'pdf'];
        
        let strValidation = $btn.attr("data-mimetype");
        
        if (strValidation != "")
		{
            arrValidations = strValidation.split("|");
		}
  
		console.log(arrValidations);
        
        var options  =
            {
                button: $btn[0],
                
                request:
                    {
                        endpoint: `/${strLang}/ajax/upload/endpoint`,
                        params: objParams
                    },
                
                
                chunking:
                    {
                        enabled: true,
						partSize: 1000000,
                        success :
                            {
                                endpoint: `/${strLang}/ajax/upload/endpoint?done`,
                                params: objParams
                            }
                        
                    },
                
                callbacks:
                    {
                        onComplete: this.onUploadComplete.bind(this, $btn, $progress),
                        onSubmitted: this.onUploadSubmitted.bind(this, $btn, $progress),
                        onProgress: this.onUploadProgress.bind(this, $btn, $progress),
                        onError: this.onUploadError.bind(this, $btn, $progress),
                    },
                    
				validation:
					{
                        allowedExtensions: arrValidations
					}
            };
        
        this.uploader = new qq.FineUploaderBasic (options);
	}
    
    onUploadError  ($_btn, $_progress, _strID, _strName, _strError)
    {
        let strLang = this.$form.find("#lang").val();
        let strMessage = strLang == "fr" ? "Impossible de téléverser ce fichier" : "Cannot upload this file";
        
    	Form.addError($_btn,strMessage);
    }
    
    onUploadComplete  ($_btn, $_progress, _strID, _strName, _json)
    {
        console.log("upload complete");
    
        $_progress.find(".progress").css("width", "100%");
    
        _json.data["filetype"] = "file";
    
        let strLang = this.$form.find("#lang").val();
    
        let objParams = $.param(_json.data)
    
        if (_json.success == 1)
        {
            //console.log("Finalizing");
            $.ajax
            (
                {
                    url: `/${strLang}/ajax/upload/finalize`,
                    data : objParams,
                    dataType: "JSON",
                    method: "POST"
                }
            ).done (this.onUploadFinalize.bind(this, $_btn));
        
            //var $inputText = $_divUploader.find("[data-wc-type='text-input-image']");
            //$inputText.val("");
        
        }
        else
        {
            //PLACMS.Notification.spawn(_json);
            //_this.resetFileUploader($_divUploader);
        }
    }
    
    onUploadProgress  ($_btn, $_progress, _strID, _strName, _iBytesLoaded, _iBytesTotal)
    {
    	console.log("progress");
    	console.log(_iBytesLoaded);
    
    	let iRatio = Math.round(_iBytesLoaded / _iBytesTotal *100);
    	
        $_progress.find(".progress").css("width", iRatio + "%");
    }
    
    onUploadSubmitted  ($_btn, $_progress, _strID, _strName)
    {
        console.log("submitted");
        console.log(_strName, _strID);
        
        $_progress.find(".filename").text(_strName);
    
        let strID = $_btn.attr("data-field");
        let $input = $_btn.siblings("#" + strID);
        
        $input.val("");
        $_btn.attr("disabled", "disabled");
    
        Form.clearError($_btn);
    }
    
    onUploadFinalize  ($_btn,  _json)
    {
        console.log(_json);
        
        if (_json.success == 1)
        {
        	let strID = $_btn.attr("data-field");
        	let $input = $_btn.siblings("#" + strID);
        	let strURI = _json.data.uri;
        	
        	$input.val(strURI);


        }
    
        $_btn.removeAttr("disabled");
        
    }
    
    bindDatePicker ()
	{
        let i18n = {
            previousMonth : 'Mois précédent',
            nextMonth     : 'Mois suivant',
            months        : ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
            weekdays      : ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
            weekdaysShort : ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam']
        };
        
        
        let $arrDates = $(".input_button_calendar");
        let me = this;
        this.arrPicker = [];
        
        $arrDates.each (function (_iIndex, _el)
		{
			let $elBtn = $(_el);
			let $txt = $elBtn.parents('fieldset').find("input[type='text']");
            let picker = new Pikaday(
                {
                    field: $txt[0],
                    format: 'YYYY-MM-DD',
                    i18n: i18n,
                    theme: 'pika-theme',
                    onSelect: me.onSelectDate.bind(me, this),
					onOpen : me.onOpenDate.bind(me, this),

                } );
            
            let strID = $elBtn.attr("id");
            console.log("ID", strID);
            me.arrPicker[strID] = (picker);
            
            $elBtn.on("click", me.showPicker.bind(me));
            
		});
        /*
        
        */
	}
    
    showPicker (_e)
	{
		let $btn = $(_e.currentTarget);
		let strID = $btn.attr("id");
		
		console.log("showPicker strID", strID);
		let picker = this.arrPicker[strID];
		
		picker.show();
		
	}
	
    onOpenDate ()
    {
        console.log("onOpenDate");
        console.log(arguments);
    }
	
	onSelectDate ()
	{
		console.log("onSelectDate");
		console.log(arguments);
	}
	
	static addError ( _$el, _strMsg )
	{
		Form.clearError(_$el);
		let $fieldset = _$el.parents('fieldset');

		$fieldset.find('div.input_wrapper').after('<p class="error">' + _strMsg + '</p>');
		$fieldset.addClass('has-error');
	}

	static clearAllErrors ( _$form )
	{
        _$form.find('fieldset.has-error').removeClass("has-error");
		_$form.find('p.error').remove();
	}

	static changeSelect ( _e )
	{
		
		let $this = $(_e.target);
		let $fieldset = $this.parents('fieldset');
		if ( ! $this.is('select') )
		{
			$this = $fieldset.find('select');
		}
		if ( $this.val() == '' )
		{
			$fieldset.removeClass('has-content');
		}
		else
		{
			$fieldset.addClass('has-content');
		}

	}

	static setFocus ( _e )
	{
		console.log('setFocus');
		Form.clearError($(_e.target));
	}
    
    static clearError ( _$el )
    {
        console.log('clearError');
        let $fieldset = _$el.parents('fieldset');
        $fieldset.addClass('has-content');
        $fieldset.removeClass('has-error');
        $fieldset.find('.error').remove();

    }

	static removeFocus ( _e )
	{
		console.log('removeFocus');
		let $this = $(_e.target);
		let $fieldset = $this.parents('fieldset');
		if ( ! ($this.is('input') || $this.is('textarea')) )
		{
			$this = $fieldset.find('input, textarea');
		}
		if ( $this.val() == '' )
		{
			$fieldset.removeClass('has-content');
		}
	}
	
	displayError (_index, _data)
	{
		if (_data.success != 0)
			return;

		let strFieldID = "#" + _data.field;
		let $field = $(strFieldID);

		if ($field)
			Form.addError($field, _data.message );
		
	}
	
	submit (_e)
	{
		_e.preventDefault();
		
		Form.clearAllErrors(this.$form);
		
		let strLang = this.$form.find("#lang").val();
		
		let objData = this.$form.serialize();
		
		$.ajax(
			{
				url:`/${strLang}/ajax/submit-form`,
				data: objData,
				dataType:"JSON",
				method:"POST"
			}
		)
			.done (this.onSubmit.bind(this));
		
		console.log("Submit")
	}
	
	onSubmit (_data)
	{
		console.log(_data);
		
		if (_data.success == 1)
		{
			this.onSuccess(_data);
			
			return;
		}
		
		let arrState = _data.state;
		
		$.each(arrState, this.displayError.bind(this));

		let $arrErrors = $("p.error");


		let $firstError = $arrErrors.first().parents("fieldset");

		if ($firstError && $firstError.length > 0)
		{

			let iScrollTo = $firstError.offset().top - this.$header.height() - 20;

			$('html, body').animate({
				scrollTop: iScrollTo
			}, 250);
		}

	}
	
	onSuccess (_data)
	{
		this.$form.empty();
		
		this.$form.append(_data.success_message);

		let iScrollTo = this.$form.offset().top - this.$header.height() - 20;
		$('html, body').animate({
			scrollTop: iScrollTo
		}, 250);

	}
}

export {Form};